import { RootState } from "src/store/store";

export namespace MainAuthSelector {

  export const isValidAuth = (state: RootState) => state.auth.isValidAuth;

}

